import React, { useState, useEffect } from "react";
import "./CommunityDetailPopup.css";
import { getServerBaseUrl } from "../../../../utils/portConfig";
import * as BBSFunctions from "../../../../functions/Functions";
import * as detailsDateFormat from "../../../../components/Util/DateFormat";
import { onClickFileNewTab } from "../../../../utils/openFileUrl";
import { ReactComponent as Polygon } from "../../../../assets/icons/polygon3.svg";
import Thumbnail from "../../../Client/Menu/Bbs/CommonThumbnail";
import CommunityCommentList from "../../../../components/Comments/CommunityCommentList";

function CommunityDetailPopup({ data, commentList, setCommentList, onClose, token, userId, getData, getCategoryName, setSettingOpen }) {
  const [originalData, setOriginalData] = useState();
  const API_SERVER_V2_URL = `${getServerBaseUrl()}/api/v2`; // API 서버 URL

  useEffect(() => {
    getCommunityDetails();
  }, []);

  //게시글 조회
  const getCommunityDetails = async () => {
    try {
      const resData = await BBSFunctions.getPatientCommunityDetail(API_SERVER_V2_URL, token, data.id);
      setCommentList(resData.comments);

      setOriginalData({
        ...originalData,
        id: resData.id,
        title: resData.title,
        content: resData.content,
        category: getCategoryName(resData.category),
        privatePost: resData.privatePost,
        userId: resData.userId,
        nickname: resData.nickname,
        createdDt: detailsDateFormat.formatKoreanDateTime(resData.createdDt),
        modifiedDt: resData.modifiedDt,
        attachments: resData.attachments,
        comments: resData.comments,
        mine: resData.mine,
      });
    } catch (error) {
      console.error("게시글 조회 에러:", error);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.className === "community-popup-overlay") {
      onClose();
    }
  };

  return (
    <div className="community-popup-overlay" onClick={handleOverlayClick}>
      {originalData && (
        <div className="community-popup">
          <div className="modal-header-close-button" style={{ color: "black" }} onClick={onClose}>
            x
          </div>
          <h2 className="community-popup-header">{originalData.title}</h2>
          <div className="community-popup-body">
            <div className="community-popup-info">
              <div>
                <span>카테고리: {originalData.category}</span>
                <span>작성일: {originalData.createdDt}</span>
              </div>
              <div>
                <span>작성자: {originalData.nickname || "탈퇴한 회원"}</span>
              </div>
            </div>
            <div className="community-popup-content" dangerouslySetInnerHTML={{ __html: originalData.content }} />
            {originalData.attachments.length > 0 && (
              <div className="community-preview-file-container">
                {originalData.attachments.map((file, index) => (
                  <div style={{ position: "relative" }} key={index} onClick={() => onClickFileNewTab(file.hlsUrl ? file.hlsUrl : file.url, file.hlsUrl !== null)}>
                    <Thumbnail file={file.thumbnailUrl} index={index} />
                    {file.hlsUrl && (
                      <div className="polygon">
                        <Polygon width={20} />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="community-popup-comments">
            <CommunityCommentList
              postId={originalData.id}
              commentList={commentList.length > 0 ? commentList : []}
              setCommentList={setCommentList}
              getNoticeDetails={() => {
                getCommunityDetails();
                getData();
              }}
              userid={userId}
              setDocorSettingOpen={setSettingOpen}
            />
            <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
              <div style={{ width: "70px" }}></div>

              <div>
                <button onClick={onClose}>닫기</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CommunityDetailPopup;
